import { APG_GATEWAY_HOST } from 'config/app'
import SPLIT_FEATURES from '../../containers/SplitContext/features'
import { get } from '../storage'

const getUrl = {
  'gt-catalogue-service': `${APG_GATEWAY_HOST}/optimus/catalogue-service`,
  'gt-layout-service': `${APG_GATEWAY_HOST}/optimus/layout-service`,
  'gt-campaign-service': `${APG_GATEWAY_HOST}/optimus/campaign-service`,
}

export function findServiceKeyword(url) {
  const keywords = [
    'gt-layout-service',
    'gt-catalogue-service',
    'gt-campaign-service',
  ]

  for (const keyword of keywords) {
    if (url?.includes(keyword)) {
      return keyword
    }
  }

  return null
}

export const getOptimusGtUrl = (serviceUrl) => {
  const flags = JSON.parse(get('SPLIT_FEATURE_FLAGS'))

  if (
    flags?.[SPLIT_FEATURES.BACK_PRDM_GT_APIGEE_MIGRATION]?.treatment === 'on'
  ) {
    const matchedKeyword = findServiceKeyword(serviceUrl)
    if (matchedKeyword) {
      return getUrl[matchedKeyword]
    } else {
      return serviceUrl
    }
  } else {
    return serviceUrl
  }
}

export const createOptimusGtUrl = (serviceUrl) => {
  const flags = JSON.parse(get('SPLIT_FEATURE_FLAGS'))

  if (
    flags?.[SPLIT_FEATURES.BACK_PRDM_GT_APIGEE_MIGRATION]?.treatment === 'on'
  ) {
    const baseUrl = getOptimusGtUrl(serviceUrl)
    const url = new URL(serviceUrl)
    const divideUrl = serviceUrl?.split(url.origin)[1] || ''

    if (serviceUrl === baseUrl) {
      return serviceUrl
    } else {
      return `${baseUrl}${divideUrl}`
    }
  } else {
    return serviceUrl
  }
}
